/**
 * Facade before TradingView component
 */
import { Suspense } from 'react';
import { connect } from 'react-redux';
import { switchCurrentTicker } from '../../Authlogic';
import RemountOnExchangeChanging from '../TradingViewChart/RemountOnExchangeChange';
import { IChartProps, chartMapStateToProps } from './genericChart';

const Chart = ({ chain, exchange, base, quote, width, height, markets, address, actionCancelOrders, isMobile, base_address, quote_address, base_decimals, quote_decimals, actionSwitchCurrent, flipped }: IChartProps) => {
  if ((!exchange || !base || !quote) || width === 0) {
    return <div/>;
  }

  return (
    <Suspense fallback={null}>
      <RemountOnExchangeChanging
        embed={false}
        intervals={[]}
        exchange={exchange}
        chain={chain}
        pair={`${base}/${quote}`}
        address={address}
        base_address={base_address}
        quote_address={quote_address}
        base_decimals={base_decimals}
        quote_decimals={quote_decimals}
        orders={[]} // chartFilterOrders(exchange, base, quote, mode, orders)}
        rawOrders={[]}
        id={Math.random()}
        canChangePair={true}
        onPairChanged={switchCurrentTicker}
        onCancelOrder={(order: any) => actionCancelOrders([order])}
        width={width}
        height={height}
        compact={isMobile}
        markets={markets}
        flipped={flipped}
      />
    </Suspense>
  );
};
export default connect(chartMapStateToProps, {})(Chart);
